import React, { FC } from 'react';

import cn from 'classnames';

import styles from '../ActionModal.module.scss';

type TControlBtnsProps = {
  onClose: () => void;
  onConfirm?: () => void;
  isDisabledConfirm?: boolean;
  isDelete?: boolean;
  buttonType?: 'button' | 'submit';
};

const ControlBtns: FC<TControlBtnsProps> = ({
  onClose,
  onConfirm,
  isDisabledConfirm,
  isDelete,
  buttonType = 'button'
}) => {
  return (
    <div className={styles.controlBtnBlock}>
      <button className={cn(styles.btn, styles.cancelBtn)} onClick={onClose}>
        Cancel
      </button>

      <button
        type={buttonType}
        className={cn(styles.btn, styles.confirmBtn, { [styles.deleteBtn]: isDelete })}
        disabled={isDisabledConfirm}
        {...(buttonType === 'button' && { onClick: onConfirm })}
      >
        Confirm
      </button>
    </div>
  );
};

export default ControlBtns;
